import Button from "devextreme-react/button";
import {useState} from "react";
import {Popup, ToolbarItem} from 'devextreme-react/popup';
import {TextBox} from "devextreme-react/text-box";
import {Validator, RequiredRule, CustomRule} from "devextreme-react/validator";
import {ValidationSummary} from "devextreme-react/validation-summary";
import { Buffer } from 'buffer';
import { useEEToolContext } from "../../../common/ee-tool/contexts/eeToolContext";
import { usePrintInternalCostTemp } from "../api/print-internal-cost-temp";
import { useGetNewEstimateNumber } from "../../../common/ee-tool/api/get-new-estimate-number";

export default function PrintInternalCostTempButton() {
    const context = useEEToolContext();
    const [isPopupVisible, setIsPopupVisible] = useState<boolean>(false);
    const [password, setPassword] = useState<string>('');

    const printInternalCost = usePrintInternalCostTemp(0, password, context.getSaveEstimateRequest());
    const newEstimateNumber = useGetNewEstimateNumber();
    const [isValid, setIsValid] = useState<boolean>(true);
    const [errorMessage, setErrorMessage] = useState<string>("");

    const getCloseButtonOptions = {
        stylingMode: 'contained',
        text: 'Close',
        type: 'normal',
        onClick: () => {
            setIsValid(true);
            setErrorMessage("");
            setIsPopupVisible(false);
        }
    };

    return (
        <>
            <Popup
                visible={isPopupVisible}
                showTitle={true}
                width={300}
                height={280}
                title={"Confirm password"}
                shading={true}
                showCloseButton={true}
                onHidden={() => {
                    setIsPopupVisible(false);
                }}
                position={'center'}
            > <ToolbarItem
                widget="dxButton"
                toolbar="bottom"
                location="after"
                disabled={printInternalCost.isLoading}
                options={{
                    stylingMode: 'contained',
                    text: 'OK',
                    validationGroup: 'printInternalCost',
                    onClick: async (e: any) => {
                        if (e.validationGroup.validate().isValid) {
                            let reportResult = await printInternalCost.mutateAsync();
                            if (!reportResult.isSuccess) {
                                setErrorMessage(reportResult.errorMessage);
                                setIsValid(false);
                                return;
                            }
                            const file = new File(
                                [Buffer.from(reportResult.data, "base64")],
                                'quote-Internal.pdf',
                                { type: 'application/pdf' });

                            const fileURL = URL.createObjectURL(file);
                            window.open(fileURL);
                        }
                    },
                }}
            />
                <ToolbarItem
                    widget="dxButton"
                    toolbar="bottom"
                    location="after"
                    options={getCloseButtonOptions}
                />
                <div>
                    <div className="dx-field">
                        <TextBox
                            mode={'password'}
                            value={password}
                            width={'100%'}
                            label='Password'
                            labelMode={'outside'}
                            inputAttr={{autocomplete: 'new-password'}}
                            onValueChanged={(e) => {
                                setIsValid(true);
                                setPassword(e.value);
                            }
                            }
                        >
                            <Validator validationGroup="printInternalCost">
                                <RequiredRule message={'Password is required'}/>
                                <CustomRule reevaluate={false} message={errorMessage} validationCallback={() => {
                                    return isValid;
                                }}></CustomRule>
                            </Validator>
                        </TextBox>
                    </div>
                    <ValidationSummary validationGroup='printInternalCost'></ValidationSummary>
                </div>
            </Popup>
            <Button
                text="Print Internal Cost"
                icon="Inscyth-Print"
                visible={true}
                onClick={async () => {
                    if (!context.quoteNumber) {
                        let estimateNumber = await newEstimateNumber.mutateAsync();
                        if (estimateNumber) context.setQuoteNumber(estimateNumber);
                    }

                    setPassword('');
                    setIsValid(true);
                    setErrorMessage("");
                    setIsPopupVisible(true);
                }}>
            </Button>
        </>
    )
}
